/**
 * Facetsearch alle voordelen.
 */

import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Provider, useDispatch } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { BrowserRouter, useHistory } from 'react-router-dom';

import FacetSearch from './layouts';
import { teasersReducer } from './store';
import { initialState } from './store/initialstate';

import getSearchUrl from './actions/getSearchUrl';

// ID te pakken krijgen uit de functions.php waar de react ingeladen wordt.
const reactAppData = window.wpApiSettings || {};
const { appSelector } = reactAppData;
const appAnchorElement = document.querySelector( appSelector );

const middlewares = [ thunk ];
const store = createStore( teasersReducer, initialState, applyMiddleware( ...middlewares ) );

if ( appAnchorElement ) {
	// Toevoegen BrowserRouter om met parameters uit history te kunnen werken
	ReactDOM.render(
		<Provider store={ store }>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</Provider>
		,
		appAnchorElement
	);
}

export default function App () {

	const history = useHistory();
	const dispatch = useDispatch();

	useEffect( () => {
		return history.listen( ( location ) => {
			/** 
			* Nadat een gebruiker vorige klikt, dient de app opnieuw geladen te worden met de desbetreffende search parameters
			*/
			if ( history.action === "POP" ) {
				dispatch( getSearchUrl() )
			}

		} )
	}, [ history ] )

	return (
		<FacetSearch />
	)
}